import { useState } from 'react';
import NoticeCard from './NoticeCard';
import './ResultsPanel.css';

const PAGE_SIZE = 10;

export default function ResultsPanel({ results, loading, selected, onSelect, onExport }) {
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState('all');
  const [expandedIds, setExpandedIds] = useState(new Set());

  const filtered = results.filter(r => {
    if (filter === 'High') return r.fit === 'High';
    if (filter === 'Medium') return r.fit === 'Medium';
    if (filter === 'Low') return r.fit === 'Low';
    return true;
  });

  const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
  const paged = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const counts = {
    High: results.filter(r => r.fit === 'High').length,
    Medium: results.filter(r => r.fit === 'Medium').length,
    Low: results.filter(r => r.fit === 'Low').length,
  };

  const toggleSelect = (id) => {
    const next = new Set(selected);
    if (next.has(id)) next.delete(id); else next.add(id);
    onSelect(next);
  };

  const toggleExpand = (id) => {
    const next = new Set(expandedIds);
    if (next.has(id)) next.delete(id); else next.add(id);
    setExpandedIds(next);
  };

  const selectAll = () => onSelect(new Set(filtered.map(r => r.id)));
  const deselectAll = () => onSelect(new Set());

  if (loading) {
    return (
      <div className="results-empty">
        <div className="empty-spinner" />
        <div className="empty-text">Suche läuft…</div>
      </div>
    );
  }

  if (results.length === 0) {
    return (
      <div className="results-empty">
        <div className="empty-icon">🔍</div>
        <div className="empty-text">Suche starten um Ausschreibungen zu finden</div>
      </div>
    );
  }

  return (
    <div className="results-panel">
      <div className="results-toolbar">
        <div className="toolbar-left">
          <span className="results-count">
            <strong>{filtered.length}</strong> Ausschreibungen
            {filtered.length !== results.length && <span className="results-total"> von {results.length}</span>}
          </span>
          <div className="fit-filters">
            {['all', 'High', 'Medium', 'Low'].map(f => (
              <button
                key={f}
                className={`fit-filter ${filter === f ? 'active' : ''} ${f !== 'all' ? `filter-${f}` : ''}`}
                onClick={() => { setFilter(f); setPage(1); }}
              >
                {f === 'all' ? 'Alle' : f}
                {f !== 'all' && <span className="filter-count">{counts[f]}</span>}
              </button>
            ))}
          </div>
        </div>
        <div className="toolbar-right">
          {selected.size > 0 && (
            <>
              <span className="sel-count">{selected.size} ausgewählt</span>
              <button className="btn btn-sm" onClick={deselectAll}>Aufheben</button>
              <button className="btn btn-primary btn-sm" onClick={onExport}>
                📋 OpenProject Export
              </button>
            </>
          )}
          <button className="btn btn-sm" onClick={selectAll}>Alle auswählen</button>
        </div>
      </div>

      <div className="cards-list">
        {paged.map(notice => (
          <NoticeCard
            key={notice.id}
            notice={notice}
            selected={selected.has(notice.id)}
            expanded={expandedIds.has(notice.id)}
            onSelect={() => toggleSelect(notice.id)}
            onExpand={() => toggleExpand(notice.id)}
          />
        ))}
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          <button className="btn btn-sm" disabled={page === 1} onClick={() => setPage(p => p - 1)}>← Zurück</button>
          <span className="page-info">Seite {page} / {totalPages}</span>
          <button className="btn btn-sm" disabled={page === totalPages} onClick={() => setPage(p => p + 1)}>Weiter →</button>
        </div>
      )}
    </div>
  );
}
